export class Employee {
    public readonly id: number;
    public readonly firstName: string;
    public readonly lastName: string;
    public readonly punu: string;
    public readonly tenantCodeList: string[];

    constructor(id: number, firstName: string, lastName: string, punu: string, tenantCodeList: string[]) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.punu = punu;
        this.tenantCodeList = tenantCodeList
    }
}